// @flow

import React, { PureComponent } from 'react';
import type { Element } from 'react';
import PropTypes from 'prop-types';

// Helpers
import classNames from 'classnames';
import { gtmEventPush } from 'utils/gtm/events';

// Components
import styles from 'components/Modal.scss';
import { connect } from 'react-redux';

import * as Actions from 'actionTypes';

/**
 * Modal React component.
 * @return {JSX | null} - react component render.
 */
class Modal extends PureComponent<*, *> {
  closeButton: ?HTMLElement;
  modalRefClose: any;
  modalRefClose2: any;

  /**
   *  Props implementation.
   */
  static propTypes = {
    isModalOpen: PropTypes.bool,
    children: PropTypes.object,
    showCloseButton: PropTypes.bool,
    extendStyle: PropTypes.string,
    closeModal: PropTypes.func,
    closeButtonID: PropTypes.string,
    modalID: PropTypes.string,
    gtmSectionName: PropTypes.string.isRequired
  };

  /**
   * Implements defaultProps().
   */
  static defaultProps: Object = {
    showCloseButton: true
  };

  /**
   * mapDispatchToProps implementation.
   * @return {object} mapped dispatch
   * @param {object} dispatch object
   */
  static mapDispatchToProps(dispatch, ownProps) {
    return {
      closeModal: () => {
        gtmEventPush({
          method: ownProps.gtmSectionName,
          args: {
            itemLabel: 'Close modal'
          }
        });
        // $FlowFixMe
        document.body.style.overflow = 'visible';
        dispatch({ type: Actions.CLOSE_MODAL });
      }
    };
  }

  /**
   * MapStateToProps implementation.
   * @return {object} new state object
   * @param {object} state object
   */
  static mapStateToProps(state: Object) {
    return {
      isModalOpen: state.ui.isModalOpen
    };
  }

  handleCloseForChild = (e: SyntheticEvent<*>) => {
    // Stop the parent receving the onClick.
    e.stopPropagation();
    this.handleClose(e);
  };

  /**
   * mapDispatchToProps implementation.
   * @return {object} mapped dispatch
   * @param {object} dispatch object
   */
  handleClose = event => {
    if (
      event.target === this.modalRefClose ||
      event.target === this.modalRefClose2
    ) {
      this.props.closeModal();
    }
  };

  focusOnCloseButton = () => {
    return this.closeButton ? this.closeButton.focus() : null;
  };

  /**
   * Render
   * @return {ReactElement} markup
   */
  render(): Element<*> | null {
    const {
      modalID,
      closeButtonID,
      showCloseButton,
      extendStyle,
      isModalOpen
    } = this.props;

    const {
      classModal,
      classModalOpen,
      classModalContent,
      classModalClose,
      classModalHidden
    } = styles;
    if (!isModalOpen) {
      return null;
    }
    return (
      <div
        id={modalID}
        className={classNames(classModal, extendStyle, classModalOpen)}
        ref={el => (this.modalRefClose = el)}
        onClick={this.handleClose}
      >
        <div className={classModalContent}>
          {showCloseButton && (
            <div className={classModalClose}>
              <button
                id={closeButtonID}
                ref={el => (this.modalRefClose2 = el)}
                onClick={this.handleCloseForChild}
              />
            </div>
          )}
          {this.props.children}
          {/* This prevent the focus to get out of the modal when using tab */}
          <button
            id="keyboard-trap"
            className={classModalHidden}
            onFocus={this.focusOnCloseButton}
          >
            keyboard trap
          </button>
        </div>
      </div>
    );
  }
}

// $FlowFixMe
export default connect(Modal.mapStateToProps, Modal.mapDispatchToProps)(Modal);



// WEBPACK FOOTER //
// ./src/Common/Modal/index.js